var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,369.8v28.4c15.7,0,28.4,12.8,28.4,28.4c0,15.7-12.8,28.4-28.4,28.4c-15.7,0-28.4-12.8-28.4-28.4 c0-15.7,12.8-28.4,28.4-28.4V369.8v-28.4c-47.1,0-85.3,38.2-85.3,85.3c0,47.1,38.2,85.3,85.3,85.3c47.1,0,85.3-38.2,85.3-85.3 c0-47.1-38.2-85.3-85.3-85.3V369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,28.4v28.4c15.7,0,28.4,12.8,28.4,28.4c0,15.7-12.8,28.4-28.4,28.4c-15.7,0-28.4-12.8-28.4-28.4 c0-15.7,12.8-28.4,28.4-28.4V28.4V0C66.6,0,28.5,38.2,28.4,85.3c0,47.1,38.2,85.3,85.3,85.3c47.1,0,85.3-38.2,85.3-85.3 c0-47.1-38.2-85.3-85.3-85.3V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,28.4v28.4c15.7,0,28.4,12.8,28.4,28.4c0,15.7-12.8,28.4-28.4,28.4c-15.7,0-28.4-12.8-28.4-28.4 c0-15.7,12.8-28.4,28.4-28.4V28.4V0c-47.1,0-85.3,38.2-85.3,85.3c0,47.1,38.2,85.3,85.3,85.3c47.1,0,85.3-38.2,85.3-85.3 c0-47.1-38.2-85.3-85.3-85.3V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,142.2v56.9c0,47.1,38.2,85.3,85.3,85.3h170.7c47.1,0,85.3-38.2,85.3-85.3v-56.9c0-15.7-12.7-28.4-28.4-28.4 s-28.4,12.7-28.4,28.4v56.9c0,15.7-12.8,28.4-28.4,28.4H170.7c-15.7,0-28.4-12.8-28.4-28.4l0-56.9c0-15.7-12.7-28.4-28.4-28.4 S85.3,126.5,85.3,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.6,256v113.8c0,15.7,12.7,28.4,28.4,28.4c15.7,0,28.4-12.7,28.4-28.4V256c0-15.7-12.7-28.4-28.4-28.4 C240.3,227.6,227.6,240.3,227.6,256"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.4aafa350d445ca1659e45aebaa03fd48.svg";
export { ForwardRef as ReactComponent };